export default __webpack_public_path__ + "assets/spain-flag.png";